import React from 'react';
import { connect } from 'react-redux';

import CareerComponent from '../components/app/Career/Career';

import * as actions from '../actions/career';

const Career = (props) => {
  return (
    <CareerComponent {...props} />
  );
};

export default connect(({ career, user }) => ({ career, user }), actions)(Career);

